import {
  Component, ChangeDetectionStrategy,
} from '@angular/core';
import * as _ from 'lodash';

import { validationErrorStub } from 'shared/product/product-advanced-search/product-advanced-search.stub';

import { DashboardSearchPiesErrorsComponent } from './dashboard-search-pies-errors.component';


@Component({
  moduleId: module.id,
  selector: 'dashboard-search-pies70-errors',
  templateUrl: './base/dashboard-search.component.html',
  styleUrls: ['./base/dashboard-search.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DashboardSearchPies70ErrorsComponent extends DashboardSearchPiesErrorsComponent {

  name: string = 'with-pies70-errors';
  text: string = 'PIES 7.0 validation errors';
  filterValue: any = _.find(validationErrorStub, {option: 'invalid-pies-70'});

}
